import React from "react";

import {
  Column,
  Columns,
  TextField as OdsTextField,
  TextFieldProps,
} from "@origin-digital/ods-core";

import { useTextFieldState } from "src/hooks";

interface IProps
  extends Omit<
    TextFieldProps,
    | "endIcon"
    | "error"
    | "helperText"
    | "name"
    | "onKeyDown"
    | "onKeyDown"
    | "onKeyUp"
    | "onBlur"
    | "onFocus"
    | "onChange"
    | "value"
  > {
  characterCount?: boolean;
  handleValidate(): void;
  id: string;
  textFieldState: ReturnType<typeof useTextFieldState>;
  transform?(value: string): string;
  onFocus(event: React.FocusEvent<HTMLInputElement>): void;
}

export const TextField: React.FC<IProps> = ({
  characterCount,
  handleValidate,
  id,
  textFieldState,
  transform,
  onFocus,
  ...rest
}) => (
  <OdsTextField
    id={id}
    name={id}
    helperText={
      characterCount ? (
        <Columns space="medium">
          <Column>{textFieldState.helperText}</Column>
          <Column width="content">{textFieldState.value.length}/10</Column>
        </Columns>
      ) : (
        textFieldState.helperText
      )
    }
    onBlur={() => {
      handleValidate();
      textFieldState.setFocus(false);
    }}
    onFocus={(event) => {
      onFocus(event);
      textFieldState.setFocus(true);
    }}
    onChange={({ target: { value } }) => {
      textFieldState.setValue(transform ? transform(value) : value);
    }}
    value={textFieldState.value}
    error={textFieldState.error}
    endIcon={
      textFieldState.value &&
      !textFieldState.error &&
      !textFieldState.focus &&
      "success"
    }
    {...rest}
  />
);
